import { forwardRef } from 'react'
import { ScaleLoader } from 'react-spinners'
import { TABLET_SIZE } from '../../core/constants/common'
import { Flex } from '../../styles/CommonStyles'
import {
	Avatar,
	DropBody,
	FlexColumn,
	Image,
	MText,
	Profile,
	ProfileItem,
} from '../../styles/layout-styles/HeaderStyles'
import Text from '../../core/utils/Text'
import CopyIcon from '../icons/CopyIcon'
import { useCopyToClipboard } from '../../core/hooks/useCopyToClipboard'
import UserSolidIcon from '../icons/UserSolidIcon'
import UserGroupIcon from '../icons/UserGroupIcon'
import LoginIcon from '../icons/LoginIcon'

const profileItems = [
	// { title: 'accountOverview', path: '/profile', icon: UserSolidIcon },
	// { title: 'referFriends', path: '/invite', icon: UserGroupIcon },
]

export const ProfileDropdown = forwardRef((props, ref) => {
	const { profile, width, onProfileItemsClicked, lang } = props

	const { copyToClip } = useCopyToClipboard()

	return (
		<DropBody minWidth='300px' style={{ padding: '0', }}
			className={`${lang === 'en' ? '!right-0' : '!left-0'}`}
			ref={ref}>
			{profile && (
				<>
					<Flex className='!justify-start !gap-2 px-3 pt-3'>
						<Profile size={width < TABLET_SIZE ? '34px' : '42px'}>
							{profile?.avatar ? (
								<Image src={profile?.avatar} alt=' ' size={width < TABLET_SIZE ? '34px' : '42px'} />
							) : (
								<Avatar size={width < TABLET_SIZE ? 18 : 22} />
							)}
						</Profile>
						<FlexColumn>
							<>
								<MText>{`${profile?.firstName || "User"} ${profile?.lastName || "user"}`}</MText>
								<MText>{profile?.email}</MText>
							</>
						</FlexColumn>
					</Flex>
					<FlexColumn className='gap-1 my-3 px-3'>
						<MText style={{ textAlign: 'start', fontSize: '0.7rem' }}>
							<Text tid='user-id' />
						</MText>
						<Flex className='relative rounded-md w-full bg-primaryOrange p-2 !justify-between'>
							<MText className='!text-white'>{profile?._id}</MText>
							<button onClick={() => { copyToClip(profile?._id) }} className='flex items-center justify-center bg-[#c53201] h-full w-[44px] rounded-md absolute rtl:left-0 ltr:right-0 top-0 cursor-pointer'>
								<CopyIcon color='#FFFFFF' size={20} />
							</button>
						</Flex>
					</FlexColumn>
					<div className='w-full border border-cardBorderLight dark:border-cardBorderDark' />
				</>
			)}
			{!profile && (
				<Flex style={{ justifyContent: 'center' }} className='my-5'>
					<ScaleLoader color='#FC6432' width={3} height={15} />
				</Flex>
			)}
			{profileItems.map((item) => (
				<ProfileItem key={item._id} onClick={() => onProfileItemsClicked('profile', item.path)}>
					<item.icon size={18} />
					<MText fontSize='0.9rem' style={{ margin: '0 10px' }}>
						<Text tid={item.title} />
					</MText>
				</ProfileItem>
			))}
			<ProfileItem last={true} onClick={() => onProfileItemsClicked('exit')}>
				<LoginIcon color='#FF5757' size={18} className="rotate-180" />
				<MText fontSize='0.9rem' style={{ margin: '0 10px' }}>
					<Text tid='logout' className='text-[#FF5757]' />
				</MText>
				<div className="transition-all w-[96%] bg-[#FF5757] h-1 rounded-b-xl absolute bottom-0 left-1/2 -translate-x-1/2" />
			</ProfileItem>
		</DropBody>
	)
})
